<template>
  <router-link :to="{ name: PATHS_NAME.POLYMARKET }" class="Drop-Menu-Item">Polymarket</router-link>
</template>

<script setup>
  import { PATHS_NAME } from "@shared/routers/consts/pathsName";
</script>

<style lang="scss">
  @import '../../../../styles/Drop-Menu-Item.scss';
</style>